<template>
  <div class="select-person-type">
    <div class="functional 1 text-neutral-600 mb-3">
      Natureza do negócio
      <span class="text-negative-600">*</span>
    </div>
    <div class="row">
      <div class="col-lg-6 mb-5 mb-lg-0">
        <div class="option">
          <bp-radio
            v-model="innerValue"
            :options="[{ id: 'PF', name: 'Pessoa física' }]"
            :disabled="disabled"
          />
          <div class="functional-2 text-neutral-400">
            Limite de saques: R$ 1.900,00/mês.
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="option">
          <bp-radio
            v-model="innerValue"
            :options="[{ id: 'PJ', name: 'Pessoa jurídica' }]"
            :disabled="disabled"
          />
          <div class="functional-2 text-neutral-400">
            Não possui limite de saque.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: String,
      default: "PF"
    },
    disabled: Boolean
  },
  data() {
    return {
      innerValue: this.value
    };
  },
  watch: {
    innerValue(newVal) {
      if (!this.disabled && newVal != this.value) {
        this.$emit("input", newVal);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.select-person-type {
  .option {
    padding: 10px 12px;
    border-radius: 4px;
    border: 1px solid var(--Semantic-Neutral-300, #a9a9a9);
  }
}
</style>
